var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"single-line":"","append-icon":"search","label":"Search by client, order or invoice"},on:{"keyup":_vm.applySearchQuery},model:{value:(_vm.searchString),callback:function ($$v) {_vm.searchString=$$v},expression:"searchString"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }